import axios from "axios";
import siteUrls from "../api-config/ApiConfig";

async function postOrResponse(url, payload) {
    try {
        return await axios.post(url, payload);
    } catch (error) {
        if (error?.response) return error.response;
        throw error;
    }
}

export const mobileOTPSignup = async (payload) => {
    return postOrResponse(siteUrls.auth.mobileSignup, payload);
};

export const mobileOTPSignUpVerify = async (payload) => {
    return postOrResponse(siteUrls.auth.mobileSignupVerify, payload);
};

export const validateEmailAvailable = async (email) => {
    return axios.post(siteUrls.auth.emailValidation, { email });
};

export const sendEmailOtp = async (email) => {
    return axios.post(siteUrls.auth.emailOtpSend, { email });
};

export const verifyEmailOtp = async (email, otp) => {
    return axios.post(siteUrls.auth.emailOtpVerify, { email, otp });
};
